import axios from 'axios';
import { axiosInstance } from '@/services/axiosInstance';

interface GeneratePublicUrlResponse {
  uploadUrl: string;
  publicUrl: string;
}

export const generatePublicUrl = async (
  fileName: string,
  containerType: string
): Promise<GeneratePublicUrlResponse> => {
  if (!fileName || !containerType) {
    throw new Error("File name and container type are required.");
  }

  try {
    const response = await axiosInstance.post('/api/generate-upload-url', {
      fileName,
      containerType,
    });

    if (!response.data?.uploadUrl || !response.data?.publicUrl) {
      throw new Error('Invalid response from generate-upload-url endpoint.');
    }

    return response.data;
  } catch (error: any) {
    console.error('Error generating public URL:', error);
    throw new Error(
      error.response?.data?.message || 'Failed to generate public URL'
    );
  }
};

export const uploadFileToAzure = async (
  uploadUrl: string,
  file: File
): Promise<void> => {
  if (!uploadUrl || !file) {
    throw new Error("Upload URL and file are required for upload.");
  }

  try {
    await axios.put(uploadUrl, file, {
      headers: {
        'Content-Type': file.type,
        'x-ms-blob-type': 'BlockBlob',
      },
    });
  } catch (error: any) {
    console.error('Error uploading file to Azure:', error);
    if (error.response) {
      console.error('Response data:', error.response.data);
      console.error('Response status:', error.response.status);
      console.error('Response headers:', error.response.headers);
    }
    throw new Error(
      error.response?.data?.message || 'Failed to upload file to Azure'
    );
  }
};